import React, {FC} from "react";
import {styled} from "@mui/material";
import {Skeleton as MuiSkeleton} from "@mui/material";
import {Grid} from "@material-ui/core";

type SkeletonType = {
  background: string
}

const Skeleton = styled(MuiSkeleton)<SkeletonType>`
  background-color: ${(props) => props.background};
  width: 100%;
  border-radius: 6px;
`

type PropsType = {
  count: number;
  background?: string;
  container?: boolean;
  height?: number;
}

const GridSkeleton: FC<PropsType> = ({
  count,
  background = '#233044',
  container = true,
  height = 224
}) => {
  const elements: JSX.Element[] = []

  for (let c = 1; c <= count; c++) {
    elements.push(
      <Grid item md={4} sm={6} xs={12} lg={3} key={c}>
        <Skeleton
          variant='rectangular'
          height={height}
          background={background}
        />
      </Grid>
    )
  }

  return (<>
    {container ? (
      <Grid container spacing={6}>
        {elements}
      </Grid>
    ) : elements}
  </>)
}

export default GridSkeleton